// extracted by mini-css-extract-plugin
export default {"tableGap":"style_tableGap__GBkPa","valueCell":"style_valueCell__HRQrc","valueEllipsis":"style_valueEllipsis__s6ul6","noNewItemsBadge":"style_noNewItemsBadge__3KeRr"};